export default __webpack_public_path__ + "static/media/Amex_logo_color.c079df77.svg";